module.exports = __webpack_public_path__ + "static/UnclickBaggageDelay-c04d9ee3953ef125a4e988a3e8619506.png";